import React, { useState, useContext, useRef, Fragment } from "react";
import { useSelector } from "react-redux";
import { DragAndDropContext } from "../../../../context/DragAndDropContext";
import "../../Column/Column.scss";
import Container from "../../../../containers/Container";
import Draggable from "../../../../containers/Draggable/Draggable";
import BUTTON from "../../Button/Button";
import Image from "../../Image/Image";
import Text from "../../Text/Text";
import Form from "../../Form/Form";
import TimerElement from "../../Timer/Timer";
import TABLEEditor from "../../TABLE/Table";
import HTMLEditor from "../../HTML/Html";
import File from "../../File/File";
import Line from "../../Line/Line";
import VideoElement from "../../Video/Video";
import RowSetting from "../ColumnSettings/RowSetting";
import ErrorBoundary from "../../../../utils/ErrorBoundary";
import Split from "react-split";
import ColumnBG from "../ColumnSettings/ColumnSettings";
import AddToolButton from "../../../Tool/AddToolButton/AddToolButton";
import * as UTILS from "../../../../utils/Utils";

const NestedColumn = (props) => {
  const { onDrag, onDragEnter, onDragOver, dragOverElement, onDragEnd, barLocation,dragOverParent,dragOverColumnIndex } =
    useContext(DragAndDropContext);
    const {selectedFont} = useSelector((state) => state.present);
  const [state, setState] = useState({
    id: null,
    editID: null,
    noContent: false,
  });

  const setIdForEditHandler = (editID) => {
    setState({
      id: editID,
    });
  };

  return (
    <Fragment key={props.index}>
      {!props.element.dataModule && (
        <div className="rowActionControl">
          <button
            onClick={() => setIdForEditHandler(props.ID)}
            className="setting-column"
          >
            <small>Settings</small>
          </button>

          <button
            onClick={() => props.cloneElement(props.element.id)}
            className="clone-item"
          >
            <img src={props.CloneICON} />
            <small>Clone</small>
          </button>

          {props.deskWidth && (
            <Fragment>
              {!props.resizeID && (
                <div className="addRemoveWrapper">
                  {props.deskWidth.length <= 5 && (
                    <span
                      onClick={(e) => {
                        props.addRemoveColumn(e, props.ID, "add");
                      }}
                      className="addColumn"
                    >
                      +<small>Add Column</small>
                    </span>
                  )}
                  {props.deskWidth.length > 1 && (
                    <span
                      onClick={(e) => {
                        props.addRemoveColumn(e, props.ID, "remove");
                      }}
                      className="removeColumn"
                    >
                      -<small>Remove Column</small>
                    </span>
                  )}
                </div>
              )}
            </Fragment>
          )}
          <span
            className="delete-item"
            onClick={() => props.deleteElement(props.element.id)}
          >
            <i className="far fa-trash-alt" />
            <small>Delete</small>
          </span>
        </div>
      )}{" "}
      <div
        className="row-container"
        id={props.ID}
        style={{ width: "100%", position: "relative" }}
      >
        <div
          style={
            props.rowStyle && {
              backgroundImage:
                (props.rowBg !== null || props.rowBg !== "") &&
                (props.rowCroppedBg == "" || props.rowCroppedBg == null)
                  ? "url('" + props.rowBg + "')"
                  : "url('" + props.rowCroppedBg + "')",
              backgroundColor:
                typeof props.rowBgColor == "string"
                  ? props.rowBgColor
                  : `rgba(
                     ${props.rowBgColor.r},
                     ${props.rowBgColor.g},
                     ${props.rowBgColor.b},
                      ${props.rowBgColor.a}
                      )`,
              backgroundRepeat: props.bgRepeat,
              opacity: props.rowOpacity ? props.rowOpacity : "1.0",
              backgroundSize: props.bgSize,
              position: "absolute",
              width: "100%",
              height: "100%",
              left: "0",
              top: "0",
            }
          }
        />
        {props.ID === state.id && (
          <RowSetting
            rowOpacity={props.rowOpacity}
            initP={props.initP}
            srcID={props.srcID}
            userID={props.userID}
            sessionID={props.sessionID}
            rowBg={props.rowBg}
            label={props.label}
            bgRepeat={props.bgRepeat}
            bgSize={props.bgSize}
            borderWidth={props.borderWidth}
            rowBgColor={props.rowBgColor}
            rowBorderColor={props.rowBorderColor}
            rowCroppedBg={props.rowCroppedBg}
            rowStyle={props.rowStyle}
            ID={props.ID}
            name={props.element.name}
            gutterSpaceBtwnCol={props.gutterSpaceBtwnCol}
            gutterSpaceBtwnColMobile={props.gutterSpaceBtwnColMobile}
            setIdForEditHandler={setIdForEditHandler}
          />
        )}
        <div
          key={props.index}
          className={
            "rowGrid" +
            (props.resizeID ? " resizeColumn" : " ") 
          }
          id={props.ID == state.editID ? " activeResize" : " "}
          style={
            props.rowStyle && {
              borderColor:
                typeof props.rowBorderColor == "string" || !props.rowBorderColor
                  ? "rgba(252, 252, 252, 0)"
                  : `rgba(
          ${props.rowBorderColor.r},
          ${props.rowBorderColor.g},
          ${props.rowBorderColor.b},
          ${props.rowBorderColor.a}
        )`,
              borderWidth: props.borderWidth + "px",
              borderStyle: "solid",
              justifyContent: "center",
              paddingTop:
                props.rowStyle && props.rowStyle.paddingTop && !props.mobileView
                  ? props.rowStyle.paddingTop +
                    (props.rowStyle.paddingUnit
                      ? props.rowStyle.paddingUnit
                      : "px")
                  : props.rowStyle &&
                    props.rowStyle.paddingTopMobile &&
                    props.mobileView
                  ? props.rowStyle && props.rowStyle.paddingTopMobile
                    ? props.rowStyle.paddingTopMobile +
                      (props.rowStyle.paddingUnit
                        ? props.rowStyle.paddingUnit
                        : "px")
                    : "0"
                  : "0",
              paddingBottom:
                props.rowStyle &&
                props.rowStyle.paddingBottom &&
                !props.mobileView
                  ? props.rowStyle.paddingBottom +
                    (props.rowStyle.paddingUnit
                      ? props.rowStyle.paddingUnit
                      : "px")
                  : props.rowStyle &&
                    props.rowStyle.paddingBottomMobile &&
                    props.mobileView
                  ? props.rowStyle && props.rowStyle.paddingBottomMobile
                    ? props.rowStyle.paddingBottomMobile +
                      (props.rowStyle.paddingUnit
                        ? props.rowStyle.paddingUnit
                        : "px")
                    : "0"
                  : "0",
            }
          }
        >
          <Fragment>
            {Object.keys(props.columns).map((col, colIndex) => {
              let isHideMobile = props.element.hideColumnOnMobile
                ? props.element.hideColumnOnMobile.find((item, index) => {
                    return col == item;
                  }) == col
                  ? true
                  : false
                : " ";
              //
              return (
                <div
                  onDragEnter={(e) => {
                    onDragEnter(e, null, null, props.element, colIndex, true);
                  }}
                  className={
                    "column" + (props.element.columns[col].length === 0 ? " noContent" : "") +
                    (dragOverParent && (dragOverParent.id === props.element.id) &
                      (dragOverColumnIndex === colIndex)
                      ? " draggedOver"
                      : "")
                  }
                  key={colIndex}
                  id={isHideMobile == true ? "hideMobile" : " "}
                  style={{
                    marginLeft:
                      props.columnGap && !props.mobileView
                        ? props.columnGap / 2 + "px"
                        : "0px",
                    marginRight:
                      props.columnGap && !props.mobileView
                        ? props.columnGap / 2 + "px"
                        : "0px",

                    marginBottom:
                      props.rowGap && props.mobileView
                        ? props.rowGap / 2 + "px"
                        : "0px",
                    

                    marginBottom:
                      !props.mobileView ? "0px" : (Object.keys(props.element.columns).length > 1) & (colIndex !== Object.keys(props.element.columns).length - 1)
                        ? props.rowGap + "px"
                        : "0px",

                    width: `calc(${
                      props.deskWidth && props.deskWidth[colIndex] + "%"
                    } - 
                            ${
                              (props.columnGap ||
                                (props.rowStyle.gutterSpaceBtwnCol &&
                                  props.rowStyle.gutterSpaceBtwnCol !== "0")) &&
                              props.deskWidth &&
                              props.deskWidth.length > 1
                                ? Number(
                                    props.columnGap ||
                                      props.rowStyle.gutterSpaceBtwnCol
                                  ) /
                                  (props.deskWidth[colIndex]
                                    ? UTILS.columnGutterDivideValue[
                                        UTILS.isFloat(props.deskWidth[colIndex])
                                          ? props.deskWidth[colIndex].toFixed(2)
                                          : props.deskWidth[colIndex]
                                      ]
                                    : 1)
                                : 0
                            }px)`,
                    // Minus value calculation
                    // if columnGap || (rowStyle.gutterSpaceBtwnCol && rowStyle.gutterSpaceBtwnCol) && deskWidth && deskWidth.length > 1
                    // (columnGap || rowStyle.gutterSpaceBtwnCol(OLD VALUES)) / deskWidth[index] ? columnGutterDivideValue[deskWidth[index] isFloat == TRUE ? deskWidth[index].toFixed(2): deskWidth[index]]]: 1: 0 + 'px'
                    backgroundColor: props.element.columnsBG
                      ? typeof props.element.columnsBG[col].bgColor == "string"
                        ? props.element.columnsBG[col].bgColor
                        : `rgba(
                      ${props.element.columnsBG[col].bgColor.r},
                      ${props.element.columnsBG[col].bgColor.g},
                      ${props.element.columnsBG[col].bgColor.b},
                      ${props.element.columnsBG[col].bgColor.a}
                    )`
                      : "",
                    paddingRight:
                      props.element.columnsBG && !props.mobileView
                        ? (!props.element.columnsBG[col].gutterSpaceRight
                            ? props.element.columnsBG[col].gutterSpace
                              ? JSON.parse(
                                  props.element.columnsBG[col].gutterSpace
                                )
                              : 15
                            : JSON.parse(
                                props.element.columnsBG[col].gutterSpaceRight
                              )) +
                          (props.element.columnsBG[col].gutterSpaceUnit
                            ? props.element.columnsBG[col].gutterSpaceUnit
                            : "px")
                        : props.element.columnsBG && props.mobileView
                        ? (!props.element.columnsBG[col].gutterSpaceMobileRight
                            ? props.element.columnsBG[col].gutterSpaceMobile
                              ? JSON.parse(
                                  props.element.columnsBG[col].gutterSpaceMobile
                                )
                              : 0
                            : JSON.parse(
                                props.element.columnsBG[col]
                                  .gutterSpaceMobileRight
                              )) +
                          (props.element.columnsBG[col].gutterSpaceUnit
                            ? props.element.columnsBG[col].gutterSpaceUnit
                            : "px")
                        : "0",
                    paddingLeft:
                      props.element.columnsBG && !props.mobileView
                        ? (!props.element.columnsBG[col].gutterSpaceLeft
                            ? props.element.columnsBG[col].gutterSpace
                              ? JSON.parse(
                                  props.element.columnsBG[col].gutterSpace
                                )
                              : 15
                            : JSON.parse(
                                props.element.columnsBG[col].gutterSpaceLeft
                              )) +
                          (props.element.columnsBG[col].gutterSpaceUnit
                            ? props.element.columnsBG[col].gutterSpaceUnit
                            : "px")
                        : props.element.columnsBG && props.mobileView
                        ? (!props.element.columnsBG[col].gutterSpaceMobileLeft
                            ? props.element.columnsBG[col].gutterSpaceMobile
                              ? JSON.parse(
                                  props.element.columnsBG[col].gutterSpaceMobile
                                )
                              : 0
                            : JSON.parse(
                                props.element.columnsBG[col]
                                  .gutterSpaceMobileLeft
                              )) +
                          (props.element.columnsBG[col].gutterSpaceUnit
                            ? props.element.columnsBG[col].gutterSpaceUnit
                            : "px")
                        : "0",

                    paddingTop:
                      props.element.columnsBG && !props.mobileView
                        ? (!props.element.columnsBG[col].gutterSpaceTopBottom_T
                            ? props.element.columnsBG[col].gutterSpaceTopBottom
                              ? JSON.parse(
                                  props.element.columnsBG[col]
                                    .gutterSpaceTopBottom
                                )
                              : 0
                            : JSON.parse(
                                props.element.columnsBG[col]
                                  .gutterSpaceTopBottom_T
                              )) +
                          (props.element.columnsBG[col].gutterSpaceUnit
                            ? props.element.columnsBG[col].gutterSpaceUnit
                            : "px")
                        : props.element.columnsBG && props.mobileView
                        ? (!props.element.columnsBG[col]
                            .gutterSpaceTopBottomMobileTop
                            ? props.element.columnsBG[col]
                                .gutterSpaceTopBottomMobile
                              ? JSON.parse(
                                  props.element.columnsBG[col]
                                    .gutterSpaceTopBottomMobile
                                )
                              : 0
                            : JSON.parse(
                                props.element.columnsBG[col]
                                  .gutterSpaceTopBottomMobileTop
                              )) +
                          (props.element.columnsBG[col].gutterSpaceUnit
                            ? props.element.columnsBG[col].gutterSpaceUnit
                            : "px")
                        : "0",
                    paddingBottom:
                      props.element.columnsBG && !props.mobileView
                        ? (!props.element.columnsBG[col].gutterSpaceTopBottom_B
                            ? props.element.columnsBG[col].gutterSpaceTopBottom
                              ? JSON.parse(
                                  props.element.columnsBG[col]
                                    .gutterSpaceTopBottom
                                )
                              : 0
                            : JSON.parse(
                                props.element.columnsBG[col]
                                  .gutterSpaceTopBottom_B
                              )) +
                          (props.element.columnsBG[col].gutterSpaceUnit
                            ? props.element.columnsBG[col].gutterSpaceUnit
                            : "px")
                        : props.element.columnsBG && props.mobileView
                        ? (!props.element.columnsBG[col]
                            .gutterSpaceTopBottomMobileBottom
                            ? props.element.columnsBG[col]
                                .gutterSpaceTopBottomMobile
                              ? JSON.parse(
                                  props.element.columnsBG[col]
                                    .gutterSpaceTopBottomMobile
                                )
                              : 0
                            : JSON.parse(
                                props.element.columnsBG[col]
                                  .gutterSpaceTopBottomMobileBottom
                              )) +
                          (props.element.columnsBG[col].gutterSpaceUnit
                            ? props.element.columnsBG[col].gutterSpaceUnit
                            : "px")
                        : "0",
                    backgroundImage: props.element.columnsBG
                      ? "url(" + props.element.columnsBG[col].bgImage + ")"
                      : "",
                    backgroundRepeat: props.element.columnsBG
                      ? props.element.columnsBG[col].bgRepeat
                      : "",
                    borderStyle: "solid",
                    borderColor:
                      typeof props.element.columnsBG[col].borderColor ==
                        "string" || !props.element.columnsBG[col].borderColor
                        ? "rgba(252, 252, 252, 0)"
                        : `rgba(
                      ${props.element.columnsBG[col].borderColor.r},
                      ${props.element.columnsBG[col].borderColor.g},
                      ${props.element.columnsBG[col].borderColor.b},
                      ${props.element.columnsBG[col].borderColor.a}
                    )`,
                    borderWidth:
                      props.element.columnsBG &&
                      props.element.columnsBG[col].borderWidth
                        ? JSON.parse(props.element.columnsBG[col].borderWidth)
                        : "",
                    backgroundSize: props.element.columnsBG
                      ? props.element.columnsBG[col].bgSize
                      : "",
                  }}
                >
                  {!props.element.dataModule && (
                    <ColumnBG
                      userID={props.userID}
                      initP={props.initP}
                      sessionID={props.sessionID}
                      element={props.element}
                      ID={props.ID}
                      BGColor={
                        props.element.columnsBG
                          ? props.element.columnsBG[col].bgColor
                          : ""
                      }
                      BGRepeat={
                        props.element.columnsBG
                          ? props.element.columnsBG[col].bgRepeat
                          : ""
                      }
                      BgImage={
                        props.element.columnsBG
                          ? props.element.columnsBG[col].bgImage
                          : ""
                      }
                      gutterSpaceUnit={
                        props.element.columnsBG &&
                        props.element.columnsBG[col].gutterSpaceUnit
                          ? props.element.columnsBG[col].gutterSpaceUnit
                          : "px"
                      }
                      gutterSpace={
                        props.element.columnsBG
                          ? props.element.columnsBG[col].gutterSpace
                          : ""
                      }
                      gutterSpaceLeft={
                        props.element.columnsBG
                          ? props.element.columnsBG[col].gutterSpaceLeft
                          : ""
                      }
                      gutterSpaceRight={
                        props.element.columnsBG
                          ? props.element.columnsBG[col].gutterSpaceRight
                          : ""
                      }
                      gutterSpaceMobile={
                        props.element.columnsBG
                          ? props.element.columnsBG[col].gutterSpaceMobile
                          : ""
                      }
                      gutterSpaceMobileLeft={
                        props.element.columnsBG
                          ? props.element.columnsBG[col].gutterSpaceMobileLeft
                          : ""
                      }
                      gutterSpaceMobileRight={
                        props.element.columnsBG
                          ? props.element.columnsBG[col].gutterSpaceMobileRight
                          : ""
                      }
                      gutterSpaceTopBottom={
                        props.element.columnsBG
                          ? props.element.columnsBG[col].gutterSpaceTopBottom
                          : ""
                      }
                      gutterSpaceTopBottom_T={
                        props.element.columnsBG
                          ? props.element.columnsBG[col].gutterSpaceTopBottom_T
                          : ""
                      }
                      gutterSpaceTopBottom_B={
                        props.element.columnsBG
                          ? props.element.columnsBG[col].gutterSpaceTopBottom_B
                          : ""
                      }
                      gutterSpaceTopBottomMobile={
                        props.element.columnsBG
                          ? props.element.columnsBG[col]
                              .gutterSpaceTopBottomMobile
                          : ""
                      }
                      gutterSpaceTopBottomMobileTop={
                        props.element.columnsBG
                          ? props.element.columnsBG[col]
                              .gutterSpaceTopBottomMobileTop
                          : ""
                      }
                      gutterSpaceTopBottomMobileBottom={
                        props.element.columnsBG
                          ? props.element.columnsBG[col]
                              .gutterSpaceTopBottomMobileBottom
                          : ""
                      }
                      BorderColor={
                        props.element.columnsBG
                          ? props.element.columnsBG[col].borderColor
                          : ""
                      }
                      BorderWidth={
                        props.element.columnsBG &&
                        props.element.columnsBG[col].borderWidth
                          ? props.element.columnsBG[col].borderWidth
                          : ""
                      }
                      ColumnNumber={col}
                      BGSize={
                        props.element.columnsBG
                          ? props.element.columnsBG[col].bgSize
                          : ""
                      }
                    />
                  )}

                  {props.columns[col] && props.columns[col].length === 0 && (
                    <AddToolButton
                      showAddElement={props.showAddElement}
                             tool={UTILS.tool.filter((item) => item.data !== "Accordion" & item.data !== "Row")}
                      disableRowTool={true}
                      ID={props.ID}
                      block={false}
                      columnNumber={col}
                      forColumn={true}
                      mobileView={props.mobileView}
                      onAddElementorColumnInColumn={
                        props.onAddElementorColumnInColumn
                      }
                    />
                  )}
                  {/* COLUMNS ELEMENTS STARTS */}
                  {props.columns[col].map((colm, colIndex) => {
                    return (
                      <Draggable
                        style={
                          dragOverElement &&
                          (dragOverElement.id === colm.id) &
                            (barLocation === "Bottom")
                            ? { borderBottom: "12px solid #C2F5B8" }
                            : dragOverElement &&
                              (dragOverElement.id === colm.id) &
                                (barLocation === "Top")
                            ? { borderTop: "12px solid #C2F5B8" }
                            : {}
                        }
                        onDrag={(e) => {
                          onDrag(e, colm, props.element, colIndex);
                        }}
                        onDragOver={(e) => {
                          onDragOver(e);
                        }}
                        onDragEnter={(e) => {
                          onDragEnter(
                            e,
                            colm,
                            colIndex,
                            props.element,
                            null,
                            true
                          );
                        }}
                        onDragEnd={onDragEnd}
                        classlist={"item"}
                        element={colm}
                        tool={UTILS.tool.filter((item) => {
                          return (
                            (item.data != "Accordion") & (item.data != "Row")
                          );
                        })}
                        key={colIndex}
                        onAddElementorColumn={props.onAddElementorColumn}
                        mobileView={props.mobileView}
                        ID={colm.id}
                        dataAttr={colm.title}
                      >
                        {colm.data == "IMAGE" ? (
                          <ErrorBoundary>
                            <Image
                              mobileView={props.mobileView}
                              mobileAlign={
                                colm.mobileAlign ? colm.mobileAlign : ""
                              }
                              pagesList={props.pagesList}
                              Link={colm.link}
                           element={colm}
                              imageMarginUnit={colm.style.imageMarginUnit}
                              imageWidthUnit={colm.style.imageWidthUnit}
                              marginTop={colm.style.marginTop || 0}
                              marginRight={colm.style.marginRight || 0}
                              marginBottom={colm.style.marginBottom || 0}
                              marginLeft={colm.style.marginLeft || 0}
                              LinkName={colm.linkname}
                              LinkType={colm.linktype}
                              LinkOpen={colm.linkopen}
                              UseSocial={colm.use_social}
                              initP={props.initP}
                              userID={props.userID}
                              key={colIndex}
                              sessionID={props.sessionID}
                              keyID={colIndex}
                              ID={colm.id}
                              label={colm.label}
                              srcID={colm.srcID}
                              src={colm.src}
                              style={colm.style}
                              edit={colm.edit}
                              imageClicked={props.imageClicked}
                              addImage={() => props.addImage(colm.id)}
                              clickedImage={props.clickedImage}
                              clickedImageID={props.clickedImageID}
                              toggleUploadPopup={props.toggleUploadPopup}
                              deleteElement={() => props.deleteElement(colm.id)}
                              width={colm.style.maxWidth}
                              height={colm.style.height}
                              radius={colm.style.borderRadius}
                              float={colm.style.float}
                              opacity={colm.style.opacity}
                              URL={colm.href}
                              changeImage={() => props.changeImage(colm.id)}
                              cloneElement={() => props.cloneElement(colm.id)}
                            />
                          </ErrorBoundary>
                        ) : colm.data == "Line" ? (
                          <ErrorBoundary>
                            <Line
                              display={colm.style.display}
                              margin={colm.style.margin}
                              key={colIndex}
                           element={colm}
                              lineMarginUnit={colm.style.lineMarginUnit}
                              marginTop={colm.style.marginTop}
                              marginRight={colm.style.marginRight}
                              marginBottom={colm.style.marginBottom}
                              label={colm.label}
                              marginLeft={colm.style.marginLeft}
                              borderColor={colm.style.borderColor}
                              borderWidth={colm.style.borderWidth}
                              backgroundColor={colm.style.backgroundColor}
                              style={colm.style}
                              preset={props.preset}
                              width={colm.style.width}
                              ID={colm.id}
                              deleteElement={() => props.deleteElement(colm.id)}
                              cloneElement={() => props.cloneElement(colm.id)}
                            />
                          </ErrorBoundary>
                        ) : colm.data == "FILE" ? (
                          <ErrorBoundary>
                            <File
                              marginTop={colm.style.marginTop || 0}
                              marginBottom={colm.style.marginBottom || 0}
                              fileMarginUnit={colm.style.fileMarginUnit}
                              fileWidthUnit={colm.style.fileWidthUnit}
                              initP={props.initP}
                              userID={props.userID}
                           element={colm}
                              key={colIndex}
                              layout={props.layout}
                              sessionID={props.sessionID}
                              keyID={colIndex}
                              ID={colm.id}
                              thumbID={colm.thumbID}
                              thumb={colm.thumb}
                              files={colm.files}
                              label={colm.label}
                              deleteElement={() => props.deleteElement(colm.id)}
                              cloneElement={() => props.cloneElement(colm.id)}
                              style={colm.style}
                              opacity={colm.style.opacity}
                              radius={colm.style.borderRadius}
                              width={colm.style.maxWidth}
                              float={colm.style.float}
                            />
                          </ErrorBoundary>
                        ) : colm.data == "TIMER" ? (
                          <ErrorBoundary>
                            <TimerElement
                              ID={colm.id}
                              date={colm.date}
                              key={colIndex}
                                    size={colm.size}
                                    element={colm}
                              patternStyle={colm.patternStyle}
                              float={colm.style.float}
                              timerMarginUnit={colm.style.timerMarginUnit}
                              fontFamily={colm.style.fontFamily}
                              label={colm.label}
                              marginTop={colm.style.marginTop}
                              marginRight={colm.style.marginRight}
                              marginBottom={colm.style.marginBottom}
                              marginLeft={colm.style.marginLeft}
                              margin={colm.style.margin}
                              deleteElement={() => props.deleteElement(colm.id)}
                              cloneElement={() => props.cloneElement(colm.id)}
                            />
                          </ErrorBoundary>
                        ) : colm.data == "TABLE" ? (
                          <ErrorBoundary>
                            <TABLEEditor
                              mobileView={props.mobileView}
                           element={colm}
                              selectedFont={selectedFont}
                              preset={props.preset}
                              tableMobileUnit={colm.tableMobileUnit}
                              tableDesktopUnit={colm.tableDesktopUnit}
                              mobileContent={colm.mobileStyle.content}
                              desktopContent={colm.desktopStyle.content}
                              isMirrored={colm.isMirrored}
                              pagesList={props.pagesList}
                              ID={colm.id}
                              label={colm.label}
                              edit={colm.edit}
                              content={colm.content}
                              key={colIndex}
                              deleteElement={() => props.deleteElement(colm.id)}
                              cloneElement={() => props.cloneElement(colm.id)}
                            />
                          </ErrorBoundary>
                        ) : colm.data == "HTML" ? (
                          <ErrorBoundary>
                            <HTMLEditor
                              mobileView={props.mobileView}
                           element={colm}
                              pagesList={props.pagesList}
                              ID={colm.id}
                              edit={colm.edit}
                              content={colm.content}
                              fontFamily={colm.style && colm.style.fontFamily}
                              key={colIndex}
                                        deleteElement={() => props.deleteElement(colm.id)}
                                        selectedFont={props.selectedFont}
                              cloneElement={() => props.cloneElement(colm.id)}
                              style={colm.style}
                              tableMobileUnit={colm.tableMobileUnit}
                              tableDesktopUnit={colm.tableDesktopUnit}
                            />
                          </ErrorBoundary>
                        ) : colm.data == "VIDEO" ? (
                          <ErrorBoundary>
                            <VideoElement
                              marginTop={colm.style.marginTop || 0}
                              marginBottom={colm.style.marginBottom || 0}
                              videoMarginUnit={colm.style.videoMarginUnit}
                              videoWidthUnit={colm.style.videoWidthUnit}
                              userID={props.userID}
                           element={colm}
                              initP={props.initP}
                              videoURL_ADDRESS={
                                colm.vimeoTHUMB
                                  ? colm.vimeoTHUMB
                                  : colm.youtubeTHUMB
                                  ? colm.youtubeTHUMB
                                  : ""
                              }
                              label={colm.label}
                              vimeoID={colm.vimeoID || null}
                              youtubeID={colm.youtubeID || null}
                              vimeoTHUMB={colm.vimeoTHUMB || null}
                              youtubeTHUMB={colm.youtubeTHUMB || null}
                              video_url={colm.video_url || null}
                              sessionID={props.sessionID}
                              showChaptersToggle={colm.showChaptersToggle}
                              if_src={colm.src}
                              key={colIndex}
                              ID={colm.id}
                              addVideo={() =>
                                props.addVideo(colm.id, colm.videoID)
                              }
                              videoOption={() => {
                                props.videoOption(colm.id);
                              }}
                              deleteElement={() => props.deleteElement(colm.id)}
                              VideoWidth={colm.style.maxWidth}
                              srcID={colm.srcID}
                              editEnable={colm.edit}
                              modalUpload={props.modalUpload}
                              selectedFile={props.selectedFile}
                              toggleUploadPopup={props.toggleUploadPopup}
                              onChangeHandler={props.onChangeHandler}
                              loaded={props.loaded}
                              videoClicked={props.videoClicked}
                              videoDataID={props.videoDataID}
                              autoplay={colm.autoplay}
                              modal={colm.modal}
                              chapters={colm.chapters}
                              control={colm.control}
                              layout={props.layout}
                              cloneElement={() => props.cloneElement(colm.id)}
                            />
                          </ErrorBoundary>
                        ) : colm.data == "BUTTON" ? (
                          <ErrorBoundary>
                            <BUTTON
                              mobileView={props.mobileView}
                              pagesList={props.pagesList}
                              Link={colm.link}
                              LinkName={colm.linkname}
                              element={colm}
                              fullWidth={colm.style.width || "auto"}
                              LinkType={colm.linktype}
                              LinkOpen={colm.linkopen}
                              UseSocial={colm.use_social}
                              deleteElement={() => props.deleteElement(colm.id)}
                              label={colm.label}
                              ID={colm.id}
                              style={colm.style}
                              mobileAlignment={colm.mobileAlignment || "none"}
                              // IDELE={id}
                              fontName={colm.style.fontFamily}
                              fontSize={colm.style.fontSize}
                              key={colIndex}
                              borderRadius={colm.style.borderRadius}
                              fontWeight={colm.style.fontWeight || "normal"}
                              borderWidthVal={colm.style.borderWidth}
                              borderWidth={colm.style.borderWidth}
                              paddingTop={colm.style.paddingTop}
                              paddingRight={colm.style.paddingRight}
                              paddingBottom={colm.style.paddingBottom}
                              paddingLeft={colm.style.paddingLeft}
                              btnPaddingUnit={colm.style.btnPaddingUnit}
                              btnMarginUnit={colm.style.btnMarginUnit}
                              marginTop={colm.style.marginTop}
                              marginRight={colm.style.marginRight}
                              marginBottom={colm.style.marginBottom}
                              marginLeft={colm.style.marginLeft}
                              floatVal={colm.style.float}
                              buttonURL={colm.buttonURL}
                              content={colm.content}
                              keyID={colm.id}
                              editVal={colm.edit}
                              editStatus={colm.edit}
                              normalTextColor={
                                colm.normalBtn.txtColor.rgb || {
                                  r: 255,
                                  g: 255,
                                  b: 255,
                                  a: 1,
                                }
                              }
                              normalBtnBg={
                                colm.normalBtn.btnBG.rgb || {
                                  r: 12,
                                  g: 50,
                                  b: 84,
                                  a: 1,
                                }
                              }
                              normalBtnBorder={
                                colm.normalBtn.btnBorder.rgb || {
                                  r: 12,
                                  g: 50,
                                  b: 84,
                                  a: 1,
                                }
                              }
                              hoverBtnTextColor={
                                colm.hoverBtn.txtColor.rgb || {
                                  r: 255,
                                  g: 255,
                                  b: 255,
                                  a: 1,
                                }
                              }
                              hoverBtnBgColor={
                                colm.hoverBtn.btnBg.rgb || {
                                  r: 0,
                                  g: 98,
                                  b: 204,
                                  a: 1,
                                }
                              }
                              hoverBorder={
                                colm.hoverBtn.btnBorder.rgb || {
                                  r: 12,
                                  g: 50,
                                  b: 84,
                                  a: 1,
                                }
                              }
                              cloneElement={() => props.cloneElement(colm.id)}
                            />
                          </ErrorBoundary>
                        ) : colm.data == "FORM" ? (
                          <ErrorBoundary>
                            <Form
                              FormObj={colm}
                              formArray={colm.fields}
                              key={colIndex}
                              ID={colm.id}
                              width={colm.style.width}
                                              borderWidth={colm.style.borderWidth}
                                              element={props.element}
                              borderStyle={colm.style.borderStyle}
                              borderRadius={colm.style.borderRadius}
                              borderColor={colm.style.borderColor}
                              formMarginUnit={colm.style.formMarginUnit}
                              fontFamily={colm.style.fontFamily}
                              label={colm.label}
                              marginTop={colm.style.marginTop || 0}
                              marginRight={colm.style.marginRight || 0}
                              marginBottom={colm.style.marginBottom || 0}
                              marginLeft={colm.style.marginLeft || 0}
                              backgroundColor={colm.style.backgroundColor}
                              color={colm.style.color}
                              email={colm.email}
                              deleteElement={() => props.deleteElement(colm.id)}
                              cloneElement={() => props.cloneElement(colm.id)}
                            />
                          </ErrorBoundary>
                        ) : colm.data == "TEXT" ? (
                          <ErrorBoundary>
                            <Text
                              selectedFont={selectedFont}
                              preset={props.preset}
                              mobileView={props.mobileView}
                              mobileAlign={
                                colm.mobileAlign ? colm.mobileAlign : ""
                              }
                              desktopAlign={
                                colm.desktopAlign ? colm.desktopAlign : ""
                              }
                              label={colm.label}
                              pagesList={props.pagesList}
                              keyID={colm.id}
                              key={colIndex}
                              itemIndex={colIndex}
                              ID={colm.id}
                           element={colm}
                              editVal={colm.edit}
                              deleteElement={() => props.deleteElement(colm.id)}
                              editOption={colm.edit}
                              lineHeightVal={colm.style.lineHeight}
                              maxWidth={colm.maxWidth}
                              textContent={colm.text}
                              cloneElement={() => props.cloneElement(colm.id)}
                              fontSize={colm.style.fontSize}
                              fontName={colm.style.fontFamily}
                              marginTop={colm.style.marginTop || 0}
                              marginRight={colm.style.marginRight || 0}
                              marginBottom={colm.style.marginBottom || 0}
                              marginLeft={colm.style.marginLeft || 0}
                            />
                          </ErrorBoundary>
                        ) : null}
                      </Draggable>
                    );
                  })}
                </div>
              );
            })}
          </Fragment>
        </div>
      </div>
    </Fragment>
  );
};
export default NestedColumn;
